<div class="image-carousel__counter" *ngIf="isCounterHidden()">
  Bild {{hasVideo ? currentSlideIndex : currentSlideIndex + 1}} / {{hasVideo ? mediaList.length - 1 : mediaList.length}}
</div>
<button mat-icon-button
        *ngIf="mediaList.length > 1 && currentSlideIndex > 0"
        (click)="prevImage($event)"
        class="image-carousel__prev">
  <mat-icon>navigate_before</mat-icon>
</button>
<div class="image-carousel__slider">
  <div #slide [style]="getSlideStyle(i)" class="image-carousel__slide"
       *ngFor="let media of mediaList; let i = index" [id]="'slide-' + i">
    <lib-lazy-image *ngIf="media.image"
                    (swipeleft)="nextImage(null, false)"
                    (swiperight)="prevImage(null, false)"
                    [lazyLoad]="i > 0 || lazyLoadImages"
                    [preload]="preloadFirstImage"
                    [picture]="media.image"
                    [style.object-fit]="media.fit"
                    [style.object-position]="media.position"
                    [targetRes]="targetRes"
                    (click)="onImageClick(currentSlideIndex, $event)"></lib-lazy-image>
    <iframe *ngIf="media.youtubeVideo"
            allow='autoplay'
            [lazyLoad]="i > 0"
            class="user-select-disabled"
            allowfullscreen="true"
            [src]="media.youtubeVideo"></iframe>
    <lib-video-player *ngIf="media.video" [video]="media.video"
                      [paywall]="paywall"
                      [autostart]="autoStartVideo && currentSlideIndex === i"
                      [user]="user"
                      [showAd]="showAds"
                      [trackingInfo]="trackingInfo"
                      class="video-player"></lib-video-player>
  </div>
</div>
<button mat-icon-button
        *ngIf="mediaList.length > 1 && currentSlideIndex < mediaList.length - 1"
        (click)="nextImage($event)"
        class="image-carousel__next">
  <mat-icon>navigate_next</mat-icon>
</button>
<div class="image-carousel__indicators" *ngIf="mediaList && mediaList.length > 1 && showAnchors">
  <a *ngFor="let image of mediaList; let i = index"
     class="image-carousel__anchor"
     [ngClass]="{active: i === currentSlideIndex}"
     (click)="changeImage(i)"></a>
</div>
<div class="image-carousel__credit"
     [ngStyle]="{bottom: creditsBottomSpace}"
     *ngIf="currentImageCredit && showCredit">
  Bild: {{currentImageCredit}}
</div>
